import { render, staticRenderFns } from "./MethodComponent.vue?vue&type=template&id=dfc0f57e"
import script from "./MethodComponent.vue?vue&type=script&lang=js"
export * from "./MethodComponent.vue?vue&type=script&lang=js"
import style0 from "./MethodComponent.vue?vue&type=style&index=0&id=dfc0f57e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports